import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
/***** Configs *****/
import { AppConfig } from '../app.config';
/***** Rxjs *****/
import { Observable } from 'rxjs';
/***** Services *****/
import { StorageService } from 'src/app/services/storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let regexFromMyArray = new RegExp(AppConfig.authDomainList.join("|"), 'gi');
    if (request.url.match(regexFromMyArray)) {
      const authToken = this.storageService.getToken();
      // console.log(authToken);
      if (authToken) {
        request = request.clone({
          setHeaders: {
            'Authorization': 'Bearer ' + authToken,
          }
        });
      }
    }
    return next.handle(request);
  }
}
